var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-tab",class:{ active: _vm.active, disabled: _vm.disabled }},[_vm._v(" "+_vm._s(_vm.$t(_vm.tab.name))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }